import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useHistory, useParams } from "react-router-dom";
import dayjs from "dayjs";

import { Box, Button, Checkbox, InputLabel, FormControlLabel, Typography, Chip, CircularProgress, FormControl, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, InputAdornment, TextField, Tooltip, IconButton } from "@mui/material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Email } from "@mui/icons-material";
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';

import { Resumo } from "./Resumo";
import { Retificacoes } from "./Retificacoes";
import { Dependentes } from "./Dependentes";
import { Arquivos } from "./Arquivos";

import { ModalConfiguracoes } from "./ModalConfiguracoes";
import { ModalAcionar } from "./ModalAcionar";



import { Container, Cell, ButtonContainer, UploadContainer, ArrowBack } from "./styled";
import { IPerson, IPosicaoCadastralResumed } from "./types";

import { useAlert } from "contexts/alert";
import { cpfMask } from "utils/cpf";
import api from "services/api";
import utc from "dayjs/plugin/utc";

import { ICResponse } from "./View";



import { Main } from "./styled";
 
dayjs.extend(utc)

function formatDate(dateToFormat: string | null) {
  try {
    if (!dateToFormat) throw new Error();
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    return dayjs(dateToFormat).utc().format("DD/MM/YYYY - HH:mm:ss");
  } catch (error) {
    return `-`;
  }
}

interface IProps {
  dates: ICResponse['campaignDates']
  resumo: ICResponse['dataResumo']
}

export function CampanhasView({ dates, resumo }: IProps) {
  const { workspaceId, templateId, workspaceActivityId } = useParams() as { workspaceId: string, templateId: string, workspaceActivityId: string };

  const tabs: string[] = ['Resumo'];
  // const tabs: string[] = ['Resumo', 'Retificações'];
  const [isModalConfiguracoesOpen, setIsModalConfiguracoesOpen] = useState<boolean>(false);
  const [isModalAcionarOpen, setIsModalAcionarOpen] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('Resumo');
  const [activityResult, setActivityResult] = useState<any>(null);
  const [active, setActive] = useState<boolean>(false);

  const campanhasDisponiveis = ['Retificações'];
  const [selecionadas, setSelecionadas] = useState<string[]>(campanhasDisponiveis);

  const [meiosDeComunicacao, setMeiosDeComunicacao] = useState<string[]>(['WhatsApp', 'E-mail']);
  const opcoesComunicacao = ['WhatsApp', 'E-mail', 'SMS'];

  function handleChangeSelecionadas(campanha: string) {
    setSelecionadas(prev =>
      prev.includes(campanha)
        ? prev.filter(item => item !== campanha)
        : [...prev, campanha]
    );
  }
    
  const history = useHistory();
  const { openAlert } = useAlert();
  const [template, setTemplate] = useState<any>(null);
 
  return (
    <>     
      <ModalConfiguracoes isOpen={isModalConfiguracoesOpen} setIsOpen={setIsModalConfiguracoesOpen}>
        <Box sx={{ p: 1 }}>
            
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Configure o envio de comunicação, dias que ficará disponível e duração da campanha.
            </Typography>

            <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {/* Meios de comunicação - Multi-select com Chips */}
              <FormControl fullWidth>
                <InputLabel id="meios-comunicacao-label">Meios de comunicação (Conector de saída)</InputLabel>
                <Select
                  labelId="meios-comunicacao-label"
                  multiple
                  value={meiosDeComunicacao}
                  onChange={(e) => setMeiosDeComunicacao(e.target.value as string[])}
                  label="Meios de comunicação (Conector de saída)"
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                      {(selected as string[]).map((value) => (
                        <Chip
                          key={value}
                          label={value}
                          onDelete={() => { /* La acción onDelete se usa para mostrar el icono */ }}
                          deleteIcon={<SettingsIcon />}
                          sx={{
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E0E0E0',
                            '& .MuiChip-deleteIcon': {
                              color: '#616161'
                            }
                          }}
                        />
                      ))}
                    </Box>
                  )}
                >
                  {opcoesComunicacao.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Frequência de envio */}
              <FormControl fullWidth>
                <InputLabel id="frequencia-label">Envio de comunicação</InputLabel>
                <Select labelId="frequencia-label" label="Envio de comunicação" defaultValue="3">
                  <MenuItem value="3">A cada 3 dias</MenuItem>
                  <MenuItem value="5">A cada 5 dias</MenuItem>
                  <MenuItem value="7">A cada 7 dias</MenuItem>
                </Select>
              </FormControl>

              {/* Duração da campanha */}
              <FormControl fullWidth>
                <InputLabel id="duracao-label">Dias da campanha</InputLabel>
                <Select labelId="duracao-label" label="Dias da campanha" defaultValue="30">
                  <MenuItem value="15">15 dias</MenuItem>
                  <MenuItem value="30">30 dias</MenuItem>
                  <MenuItem value="60">60 dias</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Ações */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
              <Button onClick={() => setIsModalConfiguracoesOpen(false)} variant="text" sx={{ color: '#525252' }}>
                Cancelar
              </Button>
              <Button 
                onClick={() => setIsModalConfiguracoesOpen(false)} 
                variant='contained'
                style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"3rem","paddingRight":"3rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              >
                Salvar
              </Button>
            </Box>
        </Box>
      </ModalConfiguracoes>

      <ModalAcionar isOpen={isModalAcionarOpen} setIsOpen={setIsModalAcionarOpen}>
        <Typography variant="body1" style={{ padding: '24px 0' }}>
          Selecione as campanhas que deseja acionar e em seguida clique em{" "}
          <strong>“Acionar campanha”</strong>
        </Typography>

        <Typography variant="body1" style={{ marginBottom: '8px' }}>
          Campanhas
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {campanhasDisponiveis.map(campanha => (
            <FormControlLabel
              key={campanha}
              control={
                <Checkbox
                  checked={selecionadas.includes(campanha)}
                  onChange={() => handleChangeSelecionadas(campanha)}
                  sx={{ color: "#3A33C2", '&.Mui-checked': { color: "#3A33C2" } }}
                />
              }
              label={campanha}
            />
          ))}
        </div>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 4 }}>
          <Button onClick={() => setIsModalAcionarOpen(false)} color="inherit">
            Cancelar
          </Button>          
          <Button
            variant='contained'
            style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
            onClick={() => {
              console.log(selecionadas);
              setIsModalAcionarOpen(false);
            }}
          >
            Acionar campanha
          </Button>
        </Box>
      </ModalAcionar>
      <Main>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '0.25rem' }}>
            <IconButton onClick={() => history.push(`/v2/workspaces/${workspaceId}`)} style={{ padding: '2px' }}>
              <ArrowBack color="primary" />
            </IconButton>
            <h1 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Campanhas</h1>
          </div>

          <div style={{"display":"flex","gap":"0.25rem", alignItems: "center"}}>            
            <Button
              variant="outlined"
              style={{
                paddingTop: "0.25rem",
                paddingBottom: "0.25rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                borderRadius: "8px",
                height: "30px",
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                fontWeight: 600,
              }}              
              onClick={() => { setIsModalConfiguracoesOpen(true); }}
            >
              Configurações
            </Button>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
          {/* Meio de comunicação */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Meios de comunicação</div>
            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
              {dates.campaignCommunicationType.map(ct => (
                <>
                  {ct === "whatsapp" && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      backgroundColor: '#F5F5F7',
                      padding: '4px 10px',
                      borderRadius: '16px',
                      width: 'fit-content'
                    }}>
                      <WhatsAppIcon style={{ fontSize: '18px', color: '#25D366' }} />
                      <span style={{ fontSize: '14px', color: '#1D1D1F' }}>WhatsApp</span>
                    </div>
                  )}
                  {ct === "email" && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      backgroundColor: '#F5F5F7',
                      padding: '4px 10px',
                      borderRadius: '16px',
                      width: 'fit-content'
                    }}>
                      <Email style={{ fontSize: '18px', color: '#4825d3' }} />
                      <span style={{ fontSize: '14px', color: '#1D1D1F' }}>Email</span>
                    </div>
                  )}
                </>
              ))}
            </div>
          </div>

          {/* Campanha iniciada */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
            <div style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Campanha iniciada</div>
            <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: 600, color: '#6F6F78' }}>
              {formatDate(dates.campaignStartDate ?? null)}
            </span>
          </div>

          {/* Campanha termina */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
            <div style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Campanha termina</div>
            <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: 600, color: '#6F6F78' }}>
              {formatDate(dates.campaignEndDate ?? null)}
            </span>
          </div>

          {/* Dados atualizados */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
            <div style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Dados atualizados</div>
            <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: 600, color: '#6F6F78' }}>
              {formatDate(String(new Date()) ?? null)}
            </span>
          </div>
        </div>

        <div style={{"display":"flex","gap":"1rem"}}>
          <div style={{ width: '100%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'row' }}>
            {tabs.map((tab: string) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  backgroundColor: activeTab === tab ? '#F1EDFF' : 'transparent',
                  color: activeTab === tab ? '#3A33C2' : '#1D1D1F',
                  fontWeight: '600',
                  fontSize: '14px',
                  border: 'none',
                  cursor: 'pointer',
                  marginRight: '8px',
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        { activeTab === 'Resumo' && (
          <Resumo
            isOpen={true}
            setIsOpen={() => {}}
            data={resumo}
          />
        )}

        { activeTab === 'Retificações' && (
          <Retificacoes
            isOpen={true}
            setIsOpen={() => {}}
          />
        )}        

        {/* <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end',"paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"24px" }}>
          <div style={{display: 'flex',"gap":"0.25rem"}}>            
            <Button              
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}              
              onClick={() => { setIsModalAcionarOpen(true); }}              
            >
              Acionar campanha
            </Button>            
          </div>
        </div> */}
      </Main>
      
    </>
  );
}
